import React from 'react';
import PDFViewer from 'pdf-viewer-reactjs';

const link =
  'https://fh.filgolf.com/files/ele/H_Requirements_and_Procedure_for_Voting.pdf';

export default function H() {
  return (
    <>
      <h5 className="is-size-5 mb-4">
        <strong>H. Requirements and Procedure for Voting</strong>
      </h5>
      <a className="button  is-link" href={link} download>
        DOWNLOAD
      </a>
      <PDFViewer
        document={{
          url: link
        }}
        rotationAngle={0}
        css="customViewer"
      />
    </>
  );
}
